export default __webpack_public_path__ + "static/media/participating.445bf955.svg";